export const USER_SETTINGS_INTL_ROOT = 'user-settings.2fa';
